import { createApp } from 'vue'
import SpotCardGrid from './SpotCardGrid'

const el = '.kb-component--spot-card-grid'
const DOMs = document.querySelectorAll(el)

export default function (Store) {
    if (DOMs && DOMs.length) {
        DOMs.forEach((SpotCardGridDOM) => {
            const spotCardData = SpotCardGridDOM.dataset.spotCard
                ? JSON.parse(SpotCardGridDOM.dataset.spotCard)
                : null
            const component = createApp(SpotCardGrid, { spotCardData }).use(
                Store
            )
            component.mount(SpotCardGridDOM)
        })
    }
}
